import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '@env/environment';

import { Countries } from '../../models/country-dump';

@Pipe({
  name: 'langToCountryCode',
  standalone: true,
  pure: true,
})
export class LangToCountryCodePipe implements PipeTransform {

  transform(value: string, codeToReturn: 'a2' | 'a3' = 'a3'): string {
    if (!value) {
      return value;
    }

    const supportedLanguages = environment.supportedLanguages;
    const language = supportedLanguages.find(supportedLanguage => supportedLanguage.startsWith(value)) || '';
    let locale = language ? language.split('-')[1].toLowerCase() : '';

    if (!locale) {
      return value;
    }

    locale = locale === 'us' ? 'gb' : locale;

    if (codeToReturn === 'a2') {
      return Countries.findA2CodeByA2(locale);
    }

    if (codeToReturn === 'a3') {
      return Countries.findA3CodeByA2(locale);
    }

    return value;
  }

}
